import Link from 'next/link';
import { IoAdd, IoPeopleOutline } from 'react-icons/io5';

import { Anchor, Box, Button, Avatar as MantineAvatar, Text } from '@mantine/core';
import { TeamHelpers } from 'src/helpers/TeamHelpers';
import { TeamUserHelpers } from 'src/helpers/TeamUserHelpers';

import { Avatar, AvatarGroup } from 'components/avatar/Avatar';
import { DashboardPanel } from 'components/dashboard-panel/DashboardPanel';
import { EmptyMessage } from 'components/empty-message/EmptyMessage';
import { useCurrentTeam } from 'hooks/use-current-team';
import { useUser } from 'hooks/use-user';

const DashboardTeam = () => {
    const team = useCurrentTeam();

    if (!team) {
        return null;
    }

    const teamUsers = TeamUserHelpers.fromTeam(team);

    return (
        <DashboardPanel
            icon={<IoPeopleOutline />}
            color="pink"
            title="Your Team"
            rightSection={
                <Anchor component={Link} href={TeamHelpers.urls.settings(team)} fw={500} fz="sm">
                    Invite
                </Anchor>
            }
        >
            {teamUsers.length > 1 ? (
                <AvatarGroup style={{ flexWrap: 'wrap', rowGap: 'var(--mantine-spacing-xs)' }}>
                    {teamUsers.map((teamUser) => (
                        <TeamMemberAvatar key={teamUser.id} userId={teamUser.user} />
                    ))}
                </AvatarGroup>
            ) : (
                <DashboardTeamEmpty />
            )}
        </DashboardPanel>
    );
};

const DashboardTeamEmpty = () => {
    const team = useCurrentTeam();

    if (!team) {
        return null;
    }

    return (
        <EmptyMessage>
            <Box c="gray.3">
                <IoPeopleOutline size={50} />
            </Box>
            <Text inherit>It's just you so far</Text>
            <Text inherit mb="xs">
                Invite your coworkers to design together
            </Text>
            <Button component={Link} href={TeamHelpers.urls.settings(team)} leftSection={<IoAdd />} size="xs">
                Invite team members
            </Button>
        </EmptyMessage>
    );
};

const TeamMemberAvatar = ({ userId }: { userId: string }) => {
    const { user } = useUser(userId);

    if (!user) {
        return <MantineAvatar size="md" />;
    }

    return <Avatar user={user} size="md" tooltip />;
};

export { DashboardTeam };
